import { render } from "./DefaultField.vue?vue&type=template&id=22c75248"
import script from "./DefaultField.vue?vue&type=script&lang=js"
export * from "./DefaultField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nekenaratafitaharitsimba/Work/HULSIA/PROJECTS/smilemood-v2/smilemood-v2-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DefaultField.vue"]])

export default __exports__